class HeadingSimple {
  private containerSelect: HTMLElement | null;
  private containerButtons: HTMLElement | null;
  private header: HTMLElement | null;

  constructor() {
    this.containerSelect = document.querySelector('.heading-simple__mobile')
    this.containerButtons = document.querySelector('.heading-simple__buttons')
    this.header = document.querySelector('header') || document.querySelector('.header');
    this._initButtons();
    this._initSelects();
  }

  private _initSelects() {
    // Selects
    const allSelectElements = this.containerSelect?.querySelectorAll('select');

    if (!allSelectElements) return
    allSelectElements.forEach(selectElement => {

      selectElement.addEventListener('change', () => {
        const selectedOption = selectElement.options[selectElement.selectedIndex];

        const targetUrl = selectedOption.dataset.target;

        if (targetUrl) {
          window.location.href = targetUrl;
        }
      });
    });
  }
  private _initButtons() {
    // Buttons (FAQ)
    const allButtons = this.containerButtons?.querySelectorAll('.heading-simple__button');

    if (!allButtons) return
    allButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const btn = e.currentTarget as HTMLButtonElement;
        const targetId = btn.getAttribute('data-target');

        if (targetId) {
          this._scrollToTarget(targetId);
        }
      });
    });
  }

  private _scrollToTarget(id: string) {
    const targetElement = document.getElementById(id);
    if (!targetElement) return;

    const headerHeight = this.header ? this.header.offsetHeight : 0;

    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

}

export const headingSimple = new HeadingSimple();
